// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fhp_","type":"styles_type__3gqBb","choices":"styles_choices__2cIFW"};